import React from "react";
import { InsuranceApplicationOptions } from "constants/billing";
import { mapDefaultDeploymentTransitInsuranceToBusinessValues } from "lib/insuranceRates";
import { FormikContextType, useFormikContext } from "formik";
import { Column, Row } from "components/Layout";
import { Label } from "./Label";
import { OptionTogglerField } from "./OptionToggler";

interface InsuranceRateProps {
  name: string;
  label: string;
  disabled?: boolean;
}

type FormValues = Partial<Business> & {
  hasTransitInsuranceForSales: boolean;
  hasTransitInsuranceForPurchases: boolean;
};

const InsuranceRate: React.FC<InsuranceRateProps> = ({
  name,
  label,
  disabled = false,
}) => {
  const formikProps = useFormikContext<FormikContextType<FormValues>>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Insurance option value from OptionTogglerField
  const onChangeTransitInsurance = (value: any) => {
    const mappedValues =
      mapDefaultDeploymentTransitInsuranceToBusinessValues(value);
    formikProps.setValues({ ...formikProps.values, ...mappedValues });
  };

  return (
    <Column>
      <Row>
        <Label>{label}</Label>
      </Row>
      <OptionTogglerField
        options={InsuranceApplicationOptions}
        name={name}
        onChangeExtra={onChangeTransitInsurance}
        disabled={disabled}
      />
    </Column>
  );
};

export default InsuranceRate;
